const API_URL =
  process.env.REACT_APP_PROJECTION_API_URL ||
  "https://acumatica-projection-event-consumer.kwfl.workers.dev";
const API_TOKEN = process.env.REACT_APP_PROJECTION_API_TOKEN;

function getProjectionUserId() {
  try {
    return (
      window.parent.document
        .getElementById("userMenu")
        .querySelector("li.menu-form > div.inline > span:nth-child(3)")
        .textContent || "unknown"
    );
  } catch (e) {
    return "unknown";
  }
}

function baseHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${API_TOKEN}`,
    "x-projection-user-id": getProjectionUserId(),
  };
}

/**
 * Fetch statuses for a batch of record identities.
 * @param {Array} records  - array of identity objects (1-500)
 * @param {AbortSignal} [signal] - optional AbortSignal to cancel stale requests
 */
export async function batchStatus(records, signal) {
  const opts = {
    method: "POST",
    headers: baseHeaders(),
    body: JSON.stringify({ records }),
  };
  if (signal) opts.signal = signal;
  const res = await fetch(`${API_URL}/projection-records/status`, opts);
  if (!res.ok)
    throw Object.assign(new Error(`Status HTTP ${res.status}`), {
      status: res.status,
    });
  return res.json();
}

/**
 * Request a rebuild for exactly one record identity.
 * @param {Object} record - identity + requestId + reason
 */
export async function rebuild(record) {
  const res = await fetch(`${API_URL}/projection-records/rebuild`, {
    method: "POST",
    headers: baseHeaders(),
    body: JSON.stringify(record),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok)
    throw Object.assign(new Error(`Rebuild HTTP ${res.status}`), {
      status: res.status,
      body,
    });
  return body;
}
